import { BrowserModule } from "@angular/platform-browser";
import {
  NgModule,
  ErrorHandler,
} from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppRoutingModule } from "@myproject/app-routing.module";
import { APP_BASE_HREF } from "@angular/common";
import { AppComponent } from "@myproject/app.component";
import { LoginComponent } from "@layouts/login/login.component";
import { AuthenticationService } from "@layouts/login/authentication.service";
import { AuthGuard } from "@myproject/auth.guard";
import { SharedService } from "@shared/shared.service";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr
} from "@angular/common/http";
import { LayoutComponent } from "@components/layout/layout.component";
import { ForgotPasswordComponent } from "@layouts/forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "@layouts/reset-password/reset-password.component";
import { RouterModule } from "@angular/router";
import { CustomPreloadingStrategy } from "@myproject/lazy-loadding.preloading";
import {
  NgbDatepickerModule,
  NgbTimepickerModule,
  NgbTooltipModule,
} from "@ng-bootstrap/ng-bootstrap";
import { SharedModule } from "@shared/shared.module";
import { AngularMultiSelectModule } from "angular2-multiselect-dropdown";
import { NgSelectModule } from "@ng-select/ng-select";
import { CustomHttpInterceptor } from "@shared/custom-http-Interceptor";
import { PageNotFoundComponent } from "@shared/errors/page-not-found.component";
import { PermissionGuard } from "@myproject/perimission.guard";
import { ResponseInterceptor } from "@myproject/reponse-interceptor";
import { ForbiddenComponent } from "@shared/errors/forbidden.component";
import { InternalServerErrorComponent } from "@shared/errors/internal-server-error.component";
import { NoInternetComponent } from "@shared/errors/no-internet.component";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { provideTranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { UnauthorizedComponent } from "@shared/errors/unauthorized.component";
import { CookieService } from "ngx-cookie-service";
import { DeviceService } from "@components/central-device/device.service";
import { AdminService } from "@components/admin/admin.service";
import { UsersService } from "@components/admin/users/users.service";
import { GroupsService } from "@myproject/components/central-device/groups/groups.service";
import { GlobalErrorHandler } from "@myproject/globalerrorhandler.service";
import { ContactUsComponent } from "./layouts/contact-us/contact-us.component";
import { FaqComponent } from "./layouts/faq/faq.component";
import { MarketplaceService } from "@components/admin/marketplace/marketplace.service";
import { SupportModule } from "./components/support/support.module";


@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    PageNotFoundComponent,
    ForbiddenComponent,
    InternalServerErrorComponent,
    NoInternetComponent,
    UnauthorizedComponent,
    ContactUsComponent,
    FaqComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgbTooltipModule,
    AppRoutingModule,
    FormsModule,
    RouterModule,
    NgxDatatableModule,
    AngularMultiSelectModule,
    SharedModule,
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    NgSelectModule,
    // OwlDateTimeModule,
    // OwlNativeDateTimeModule,
    ReactiveFormsModule,
    SupportModule,
  ],
  providers: [
    AuthGuard,
    PermissionGuard,
    AuthenticationService,
    SharedService,
    CookieService,
    DeviceService,
    AdminService,
    UsersService,
    GroupsService,
    CustomPreloadingStrategy,
    MarketplaceService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: APP_BASE_HREF, useValue: "." },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: "./assets/i18n/",
        suffix: ".json",
      }),
      fallbackLang: "en",
    }),
  ],
})
export class AppModule {}
